import DefaultToOneTimeShipToState from "@gemeco/Store/Components/DefaultToOneTimeShipTo/DefaultToOneTimeShipToState";
import { GemecoActions } from "@gemeco/Store/GemecoState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<DefaultToOneTimeShipToState, DispatchProp<GemecoActions>>;

export const SetupInitialState: HandlerType = props => {
    props.dispatch({
        type: "SetupInitialState/DefaultToOneTimeShipTo",
        parameter: props.parameter,
    });
};

export const chain = [SetupInitialState];

const setUpIntialValueDefaultShipTo = createHandlerChainRunner(chain, "DefaultToOneTimeShipTo");
export default setUpIntialValueDefaultShipTo;